export const singleNewsUK = state => state.singleNews.singleNewsUK;
export const singleNewsRU = state => state.singleNews.singleNewsRU;
export const singleNewsErrorUK = state => state.singleNews.singleNewsErrorUK;
export const singleNewsErrorRU = state => state.singleNews.singleNewsErrorRU;
export const singleNewsLoading = state => state.singleNews.loading;
